import { Component, Vue } from 'vue-property-decorator';
import * as MemberApiController from '../api/MemberApiController';
import { LoginModel } from '../api/viewmodels/LoginModel';
import { ForgotPasswordModel } from '../api/viewmodels/ForgotPasswordModel';
import { ResetPasswordModel } from '../api/viewmodels/ResetPasswordModel';

@Component
export default class ForgotPassword extends Vue {

    email: string = '';
    newPassword: string = '';
    newPasswordConfirm: string = '';
    passwordResetAlerts: string[] = [];

    showAlert: boolean = false;
    alertText: string = '';
    alertColor: string = '';

    loading: boolean = false;

    created() {
        if (this.$route.query.guid !== null && this.$route.query.guid !== undefined && this.$route.query.guid !== '') {
            MemberApiController.verifyGuid(<string>this.$route.query.guid)
                .then((response) => {
                    if (!response.data.success) {
                        this.alertColor = 'error';
                        this.alertText = 'Er kon geen aanvraag gevonden worden met het aangegeven id. Vraag alstublieft opnieuw een aanvraag aan via de wachtwoord vergeten pagina.';
                        this.showAlert = true;
                    }
                })
                .catch((error) => {
                    this.alertColor = 'error';
                    this.alertText = 'Er is een fout opgetreden bij het verifiëren van het id. Probeer het alstublieft opnieuw.';
                    this.showAlert = true;
                })
        }
        
    }

    submit() {
        if (this.loading) {
            return;
        }
        this.loading = true;

        var model: ForgotPasswordModel = {
            email: this.email
        }
        MemberApiController.passwordForgotten(model)
            .then((result) => {
                if (result.data.success) {
                    this.showAlert = true;
                    this.alertColor = "success";
                    this.alertText = "We hebben een mail verstuurd naar het opgegeven e-mailadres. Volg de instructies om uw wachtwoord opnieuw in te stellen.";
                }
                else {
                    this.showAlert = true;
                    this.alertColor = "error";
                    this.alertText = "Het opgegeven e-mailadres kon niet gevonden worden in de database. Controleer of u het juist heeft geschreven en probeer het opnieuw.";
                }
                this.loading = false;
            })
            .catch((error) => {
                this.showAlert = true;
                this.alertColor = "error";
                this.alertText = "Er is een fout opgetreden bij de aanvraag. Probeer het opnieuw.";
                this.loading = false;
            });
    }

    submitPasswordChange() {
        this.showAlert = false;

        this.passwordResetAlerts = [];
        var hasErrors: boolean = false;
        if (this.newPassword == '') {
            this.passwordResetAlerts.push("Vul een nieuw wachtwoord in");
            hasErrors = true;
        }

        if (this.newPassword != '' && this.newPassword.length < 10) {
            this.passwordResetAlerts.push("Uw wachtwoord moet minimaal 10 tekens lang zijn");
            hasErrors = true;
        }

        if (this.newPassword != '' && this.newPassword.length > 255) {
            this.passwordResetAlerts.push("Uw wachtwoord mag maximaal 255 tekens lang zijn");
            hasErrors = true;
        }

        if (this.newPasswordConfirm == '') {
            this.passwordResetAlerts.push("Bevestig uw nieuwe wachtwoord");
            hasErrors = true;
        }

        if (this.newPassword !== this.newPasswordConfirm) {            
            this.passwordResetAlerts.push("De opgegeven wachtwoorden zijn niet gelijk.")
            hasErrors = true;
        }

        if (hasErrors) {
            this.showAlert = true;
            this.alertColor = "error";
            return;
        }

        var model: ResetPasswordModel = {
            guid: <string>this.$route.query.guid,
            confirmPassword: this.newPasswordConfirm,
            password: this.newPassword
        };
        MemberApiController.passwordreset(model)
            .then((response) => {
                if (response.data.success) {
                    this.passwordResetAlerts.push("Uw wachtwoord is aangepast. U kunt nu inloggen met het nieuwe wachtwoord.");
                    this.showAlert = true;
                    this.alertColor = "success";
                }
                else {
                    this.passwordResetAlerts.push("Het wachtwoord kon niet aangepast worden. Probeer het nog eens.");
                    this.showAlert = true;
                    this.alertColor = "error";
                }
            })
            .catch((error) => {
                this.passwordResetAlerts.push("Het wachtwoord kon niet aangepast worden. Probeer het nog eens.");
                this.showAlert = true;
                this.alertColor = "error";
            });
    }
}
